export const dashCaseToNormalCase = (text: string): string =>
    text
        .replace(/([A-Z])/g, '$1')
        .replace(/-/g, ' ')
        .trim()